import axios from 'axios'
import EventBus from './EventBus'

require('es6-promise').polyfill();

const clientInstance = axios.create({
	timeout: 10000,
	headers: {'x-ajax-call': true}
});

clientInstance.interceptors.response.use(function (response) {

    return response;
}, function (error) {

    if(error.response) {
        if(error.response.data) {
          //  console.error(error.response.data)
        }
        if(error.response.status === 401) {
            document.location.href = "/login?logout=true";
        }
        // Anti-abuse Phase 1: an unverified user tried a gated action (e.g. messaging a host).
        // Surface the global "verify your email" modal. Still reject so the calling component
        // can stop its own spinner; the modal is shown regardless.
        if(error.response.status === 403 && error.response.data
                && error.response.data.code === 'EMAIL_VERIFICATION_REQUIRED') {
            EventBus.$emit('emailVerificationRequired', error.response.data);
        }
        // Anti-abuse Phase 2: email verified but phone not — surface the phone-verify prompt.
        if(error.response.status === 403 && error.response.data
                && error.response.data.code === 'PHONE_VERIFICATION_REQUIRED') {
            if (window.showPhoneVerificationModal) {
                window.showPhoneVerificationModal(error.response.data.message);
            }
            EventBus.$emit('phoneVerificationRequired', error.response.data);
        }
    }

    return Promise.reject(error);
});


export default clientInstance;




// WEBPACK FOOTER //
// ./src/main/frontend/vue/js/api/Http.js